(() => {
  if (window.PharmaVestConsent) return;
  window.PharmaVestConsent = true;

  let apiRequest;
  const videos = () => [...document.querySelectorAll('[data-pv-video]')];
  const privacy = () => window.Shopify?.customerPrivacy;
  const status = (message = '') => {
    document.querySelectorAll('[data-pv-cookie-status]').forEach((element) => {
      element.textContent = message;
    });
  };

  function videoConsent() {
    try {
      // Require an explicit choice even outside opt-in regions. Do not infer
      // permission for YouTube from Shopify's regional defaults alone.
      return privacy()?.currentVisitorConsent?.().marketing === 'yes' &&
        privacy()?.marketingAllowed?.() === true;
    } catch (_) {
      return false;
    }
  }

  function closeVideo(video, restoreFocus = false) {
    video.querySelector('[data-pv-video-player]').replaceChildren();
    video.querySelector('[data-pv-video-placeholder]').hidden = false;
    video.querySelector('[data-pv-video-stop]').hidden = true;
    if (restoreFocus) {
      video.querySelector(videoConsent() ? '[data-pv-video-play]' : '[data-pv-cookie-settings]').focus();
    }
  }

  function updateVideos() {
    const allowed = videoConsent();
    videos().forEach((video) => {
      const hadFocus = video.contains(document.activeElement);
      if (!allowed) closeVideo(video);
      video.querySelector('[data-pv-video-play]').hidden = !allowed;
      video.querySelector('[data-pv-cookie-settings]').hidden = allowed;
      video.querySelector('[data-pv-video-notice]').textContent = allowed
        ? 'YouTube kan bruge cookies og behandle oplysninger om din brug af videoen. Tryk på Afspil video for at indlæse den.'
        : 'Videoen vises via YouTube, som kan bruge cookies og behandle oplysninger om din brug af videoen. Tillad markedsføringscookies i cookieindstillingerne for at afspille den her.';
      if (!allowed && hadFocus) video.querySelector('[data-pv-cookie-settings]').focus();
    });
  }

  function loadPrivacy() {
    if (typeof privacy()?.currentVisitorConsent === 'function') return Promise.resolve();
    if (apiRequest) return apiRequest;
    apiRequest = new Promise((resolve, reject) => {
      const timer = window.setTimeout(() => reject(new Error('Privacy API timeout')), 8000);
      if (typeof window.Shopify?.loadFeatures !== 'function') {
        window.clearTimeout(timer);
        reject(new Error('Privacy API unavailable'));
        return;
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        window.clearTimeout(timer);
        if (error || typeof privacy()?.currentVisitorConsent !== 'function') reject(error || new Error('Privacy API unavailable'));
        else resolve();
      });
    }).catch((error) => {
      apiRequest = undefined;
      throw error;
    });
    return apiRequest;
  }

  async function showPreferences(button) {
    button.disabled = true;
    status();
    try {
      await loadPrivacy();
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      status('Cookieindstillingerne kunne ikke åbnes. Prøv at genindlæse siden. Videoerne er fortsat blokeret uden dit samtykke.');
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pv-cookie-settings], [data-pv-video-play], [data-pv-video-stop]');
    if (!button) return;
    if (button.hasAttribute('data-pv-cookie-settings')) {
      showPreferences(button);
      return;
    }
    const video = button.closest('[data-pv-video]');
    if (!video) return;
    if (button.hasAttribute('data-pv-video-stop')) {
      closeVideo(video, true);
      return;
    }
    if (!videoConsent()) {
      updateVideos();
      showPreferences(video.querySelector('[data-pv-cookie-settings]'));
      return;
    }
    const id = video.dataset.pvVideo;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    const player = video.querySelector('[data-pv-video-player]');
    if (player.querySelector('iframe')) return;
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    frame.title = video.dataset.videoTitle;
    frame.width = '560';
    frame.height = '315';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    video.querySelector('[data-pv-video-placeholder]').hidden = true;
    video.querySelector('[data-pv-video-stop]').hidden = false;
    player.append(frame);
    frame.focus();
  });

  function initialize() {
    document.querySelectorAll('[data-pv-cookie-settings]').forEach((button) => { button.hidden = false; });
    updateVideos();
    if (videos().length) loadPrivacy().then(updateVideos).catch(() => updateVideos());
  }

  document.addEventListener('visitorConsentCollected', updateVideos);
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
